import React from 'react';
// import TeacherMasterLayout from '../../../layouts/gcstaff/staffMasterLayout/TeacherMasterLayout';
import TeacherMasterLayout from '../../../layouts/gcstaff/staffmasterlayout/TeacherMasterLayout';
import TeacherNotificationsPage from '../../../subsreens/gcstaff/teachernotifications/TeacherNotificationsPage';


const TeacherNotifications = () => {
    return(
       <TeacherMasterLayout>
        <TeacherNotificationsPage></TeacherNotificationsPage>
       </TeacherMasterLayout>
    )
}

export default TeacherNotifications;